import { useEffect, useState } from 'react';

/**
 * Renvoie `value` avec un retard : la valeur ne se propage qu'après `delayMs` sans changement.
 *
 * Sert à la recherche instantanée — sans anti-rebond, chaque touche partirait en requête. On
 * annule le minuteur à chaque frappe, si bien que seule la dernière valeur stable est émise.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
